import LearningPathwayList from "./LearningPathwayList";

export default LearningPathwayList;
